import React, { Component } from 'react';
import './../../assets/css/App.css';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableRowColumn from './../../component/table/table/TableRowColumn';
import TableHead from './../../component/table/table/TableHead';
import TableHeaderColumn from './../../component/table/table/TableHeaderColumn';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import Utils from './../../component/utils/utils';

class TableView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "Shipments per day",
        pagingMetadata: [],
        responseTableData: {}
    }

    constructor() {
        super();
        // setting default attribute values
        this.currentPage = 0;
        this.searchFieldValuesObject = {};
        this.selectDropdownloIntervalValuesForThreeMonth = Utils.selectDropdownloIntervalValuesForThreeMonth;
    }

    componentDidMount () {
        Service.event.onFetchShipmentStatsPerDay.add((data) => {
            console.log("*** DATA");
            console.log(data);
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }

    // table actions
    searchButtonAction = (intervalOfDays) => {
        Service.fetchShipmentStatsPerDay(intervalOfDays, 'table');
    };

    jumpToPage = (e) => {
        e.preventDefault();
        var page = e.currentTarget.attributes.getNamedItem('data-page').value;
        this.currentPage = Number(page);
        this._callServiceFetch(page);
    };

    goForwardToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage + 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    goBackToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    jumpToFirstPage = (e) => {
        e.preventDefault();
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToLastPage = (e) => {
        e.preventDefault();
        this.currentPage = Number(this.state.pagingMetadata.pageCount);
        this._callServiceFetch(this.currentPage);
    };

    createTableRowColumns = () => {
        var rowColumnComponentList = [];
        if (this.state.responseTableData.results !== undefined) {
            rowColumnComponentList = this.state.responseTableData.results.map(function(item, index) {
                var rowColumnComponent = {};
                rowColumnComponent = <tr key={index}>
                    <TableRowColumn>{item.dateShiped}</TableRowColumn>
                    <TableRowColumn>{item.count}</TableRowColumn>
                </tr>
                return rowColumnComponent;
            });
        } else {
            rowColumnComponentList.push(<tr key="0"><td colSpan="8">{this.state.emptyTableMessage}</td></tr>);
        }
        return rowColumnComponentList;
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                        selectDropdownValues = {this.selectDropdownloIntervalValuesForThreeMonth}
                    ></TableSearchHeader>
                   <TableHead>
                       <tr>
                           <TableHeaderColumn>Date</TableHeaderColumn>
                           <TableHeaderColumn>Sent shipments per day</TableHeaderColumn>
                       </tr>
                   </TableHead>
                   <TableBody>
                           {this.createTableRowColumns()}
                   </TableBody>
                    <TablePagination
                        pagingMetadata={this.state.pagingMetadata}
                        jumpToPage={this.jumpToPage}
                        goForwardToPage={this.goForwardToPage}
                        goBackToPage={this.goBackToPage}
                        jumpToFirstPage={this.jumpToFirstPage}
                        jumpToLastPage={this.jumpToLastPage}>
                    </TablePagination>
                </Table>
            </div>
        );
    }
}

export default TableView;